/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import { guardCall } from '../lib/officeHours.js'
import { useState } from 'react'
import footerLogo from '../assets/footer-logo.svg'
import { FooterAparat, FooterInstagram, FooterWhatsapp } from './icons.jsx'

const MAPS =
  'https://www.google.com/maps/dir//Tehran+Province,+Tehran,+District+1,+4th+Narenjestan+St,+QFWG%2BGCJ+Sequoia+Fitness+Studio+%7C+استودیو+فیتنس+سکویا,+Iran%E2%80%AD/@35.796426,51.4734641,17z/data=!4m17!1m7!3m6!1s0x3f8e05002f1ea5e1:0x50edb98b1a04ce7b!2zU2VxdW9pYSBGaXRuZXNzIFN0dWRpbyB8INin2LPYqtmI2K_bjNmIINmB24zYqtmG2LMg2LPaqdmI24zYpw!8m2!3d35.796426!4d51.476039!16s%2Fg%2F11w__5zgzj!4m8!1m0!1m5!1m1!1s0x3f8e05002f1ea5e1:0x50edb98b1a04ce7b!2m2!1d51.476029!2d35.7964415!3e0!5m2!1e4!1e1?entry=ttu&g_ep=EgoyMDI2MDEwNC4wIKXMDSoKLDEwMDc5MjA2OUgBUAM%3D'

const LINKS = [
  { href: '/', label: 'صفحه‌ی اصلی' },
  { href: '#', label: 'درباره‌ی ما' },
  { href: '/sequoia-library/', label: 'ویدیوهای تمرینی' },
  { href: '/academy', label: 'آکادمی سکویا' },
  { href: '/links', label: 'تماس با ما' },
  { href: '#', label: 'مدیریت کوکی‌ها', consent: true },
]

function FooterLogo({ className, imgClass }) {
  return (
    <a className={className} href="https://sequoia.fitness" aria-label="سکویا فیتنس">
      <img className={imgClass} src={footerLogo} alt="" width="130" height="130" />
    </a>
  )
}

function Newsletter() {
  const [state, setState] = useState({ busy: false, msg: '', ok: false })
  const submit = (e) => {
    e.preventDefault()
    if (state.busy) return
    const form = e.currentTarget
    const phone = form.elements['phone'].value
    setState({ busy: true, msg: '', ok: false })
    fetch('https://app.sequoia.fitness/api/landing/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone, referrer: location.href }),
    })
      .then((r) => r.json().catch(() => ({})).then((j) => ({ ok: r.ok && j.ok !== false, msg: j.message || '' })))
      .then(({ ok, msg }) => {
        if (ok) form.reset()
        setState({ busy: false, msg, ok })
      })
      .catch(() => setState({ busy: false, msg: 'Server error. Please try again.', ok: false }))
  }
  return (
    <form className="lp-form" method="post" name="A" onSubmit={submit} style={{ opacity: state.busy ? 0.45 : 1 }}>
      <div className="lp-form-fields">
        <div className="lp-form-field">
          <label className="lp-form-label" htmlFor="form-field-message">اطلاع از آخرین اخبار و جشنواره‌های سکویا</label>{' '}
          <input
            className="lp-form-input"
            size="1"
            type="tel"
            name="phone"
            id="form-field-message"
            placeholder="شماره واتس‌اپ"
            required
            aria-required="true"
            pattern="[0-9()#&+*\-=.]+"
            title="فقط شماره ها و کاراکترهای تلفن (#, -, *, etc) پذیرفته می شوند."
          />
        </div>
        <div className="lp-form-submit">
          <button className="lp-form-btn" type="submit" disabled={state.busy}>
            <span className="lp-form-btn-s">
              <span className="lp-form-btn-t">ارسال</span>
            </span>
          </button>
        </div>
      </div>
      {state.msg && (
        <div className={'lp-form-msg ' + (state.ok ? 'is-ok' : 'is-err')} role="alert">
          {state.msg}
        </div>
      )}
    </form>
  )
}

export default function Footer() {
  return (
    <div className="lp-foot lp-root">
      <div className="lp-foot-box" id="seq-footer">
        <div className="lp-foot-in">
          <div className="lp-foot-m">
            <div className="lp-foot-logo-m" data-fx="foot-m">
              <div className="lp-foot-m-logo-c">
                <div className="lp-foot-logo-mw">
                  <FooterLogo className="lp-foot-logo-ma" imgClass="lp-foot-logo-ms" />
                </div>
              </div>
            </div>
          </div>
          <div className="lp-foot-cols">
            <div className="lp-foot-col-l" data-fx="foot-l">
              <div className="lp-list">
                <ul className="lp-list-ul">
                  {LINKS.map((l) => (
                    <li className="lp-list-li" key={l.label} {...(l.consent ? { 'data-seq-consent-open': '', hidden: true } : {})}>
                      <a className="lp-list-a" href={l.href}>
                        <span className="lp-list-ico">
                          <i className="lp-list-i icon icon-minus" aria-hidden="true"></i>{' '}
                        </span>
                        <span className="lp-list-txt">{l.label}</span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="lp-fbtn">
                <div className="lp-fbtn-w">
                  <a className="lp-fbtn-a" href="https://app.sequoia.fitness/support" target="_blank" rel="noopener">
                    <span className="lp-fbtn-s">
                      <span className="lp-fbtn-t">مشاوره‌ی رایگان</span>
                    </span>
                  </a>
                </div>
              </div>
            </div>
            <div className="lp-foot-col-c" data-fx="foot-c">
              <div className="lp-foot-logo" data-fx="foot-logo">
                <div className="lp-foot-logo-c">
                  <div className="lp-foot-logo-w">
                    <FooterLogo className="lp-foot-logo-a" imgClass="lp-foot-logo-s" />
                  </div>
                </div>
              </div>
              <div className="lp-soc">
                <div className="lp-soc-w">
                  <a className="lp-soc-a" href="https://t.me/sequoiafitness_channel" target="_blank" rel="nofollow" aria-label="Telegram">
                    <i className="lp-soc-i icon icon-telegram" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
              <div className="lp-soc">
                <div className="lp-soc-w">
                  <a className="lp-soc-a" href="https://www.youtube.com/@Sequoia.fitness" target="_blank" rel="noreferrer" aria-label="YouTube">
                    <i className="lp-soc-i icon icon-youtube-1" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
              <div className="lp-soc-ig">
                <div className="lp-soc-ig-w">
                  <a className="lp-soc-ig-a" href="https://instagram.com/app_sequoia" target="_blank" rel="noreferrer" aria-label="Instagram">
                    <FooterInstagram className="lp-soc-ig-s" />
                  </a>
                </div>
              </div>
              <div className="lp-soc-ig lp-soc-ap">
                <div className="lp-soc-ig-w">
                  <a className="lp-soc-ig-a" href="https://www.aparat.com/sequoia_fitness" target="_blank" rel="noreferrer" aria-label="Aparat">
                    <FooterAparat className="lp-soc-ig-s" />
                  </a>
                </div>
              </div>
              <div className="lp-foot-div">
                <div className="lp-div">
                  <div className="lp-div-w">
                    <span className="lp-div-s"></span>
                  </div>
                </div>
              </div>
              <div className="lp-news">
                <div className="lp-news-t">
                  <p className="lp-news-h">اطلاع از آخرین اخبار، دورهمی‌ها و جشنواره‌های سکویا</p>
                </div>
                <div className="lp-news-f">
                  <Newsletter />
                </div>
              </div>
            </div>
            <div className="lp-foot-col-r" data-fx="foot-r">
              <div className="lp-list2">
                <ul className="lp-list2-ul">
                  <li className="lp-list2-li">
                    <a className="lp-list2-a" href={MAPS} target="_blank" rel="nofollow">
                      <span className="lp-list2-ico">
                        <i className="lp-list2-i icon icon-map-marker1" aria-hidden="true"></i>{' '}
                      </span>
                      <span className="lp-list2-txt">
                        تهران، فرمانیه، مجتمع آرتمیس،
                        <br />
                        طبقه ۱۱، واحد یک
                      </span>
                    </a>
                  </li>
                  <li className="lp-list2-li">
                    <a className="lp-list2-a" href="tel:02126254146" target="_blank" rel="nofollow" onClick={guardCall}>
                      <span className="lp-list2-ico">
                        <i className="lp-list2-i icon icon-phone" aria-hidden="true"></i>{' '}
                      </span>
                      <span className="lp-list2-txt">۴۶ ۴۱ ۲۵ ۲۶ ۰۲۱</span>
                    </a>
                  </li>
                  <li className="lp-list2-li">
                    <a className="lp-list2-a" href="http://wa.me/989195559535" target="_blank" rel="nofollow">
                      <span className="lp-list2-ico">
                        <FooterWhatsapp className="lp-list2-svg" />{' '}
                      </span>
                      <span className="lp-list2-txt">۵۳۵ ۰ ۵۵۵ ۰۹۱۹</span>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="lp-seal">
                <div className="lp-seal-in">
                  <a
                    className="lp-seal-a"
                    aria-label="نماد اعتماد الکترونیکی (اینماد)"
                    referrerPolicy="origin"
                    target="_blank"
                    rel="nofollow"
                    href="https://trustseal.enamad.ir/?id=635848&Code=HWcy5MT4nHrZ8Kn2Bwk4xV0QnCPYTjIm"
                  >
                    <img
                      className="lp-seal-img"
                      src="/a/enamad.webp"
                      alt=""
                      style={{ cursor: 'pointer' }}
                      loading="lazy"
                      decoding="async"
                      width="125"
                      height="136"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="lp-foot-copy">
            <div className="lp-copy-t">
              <p className="lp-copy-p">
                تمامی حقوق مادی و معنوی این وب‌سایت، متعلق به استودیو سکویاست.
                <br />
                استفاده از محتوا فقط با ذکر منبع مجاز است.
              </p>
            </div>
          </div>
          <div className="lp-foot-credit">
            <div className="lp-credit-in">
              <p className="lp-credit-p">
                Designed and Developed by <a className="lp-credit-a" href="#" target="_blank" rel="noreferrer">Pouria Shabani</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
